var isVisible = function isVisible(obj) {
  return obj.offsetWidth > 0 && obj.offsetHeight > 0;
};

export default isVisible;